export default "__VITE_ASSET__18bc347b__"